import React, { useEffect, useState } from 'react';
import {
    Badge,
    BlockStack,
    Box,
    Button,
    Card,
    Divider,
    Icon,
    InlineStack,
    Link,
    Modal,
    Tabs,
    Text,
    Thumbnail,
} from '@shopify/polaris';
import { RiskMinor } from '@shopify/polaris-icons';
import { CustomTabs } from '../../../CustomTab/CustomTab';
import { useMediaQuery } from '../../../Utilities/useMediaQuery';
import getClass from '../../../Utilities/getClass';
import { DI, DIProps } from '../../../../Core';
import { t } from 'i18next';

interface Props extends DIProps {
    type: any;
    id: any;
    viewProductError: any;
    setViewProductError: any;
    activityRefreshAction: () => void
}

const ErrorModal = (props: Props) => {
    const { type, id, viewProductError, setViewProductError, di, error: showError, activityRefreshAction } = props
    const [responseData, setResponseData] = useState<any>(null);
    const [selectedMainTab, setSelectedMainTab] = useState(0); // Error, Warning, In-progress
    const [selectedSubTabs, setSelectedSubTabs] = useState([0, 0, 0]); // 0 = parent, 1 = variant per tab

    const isMobileView = useMediaQuery('(max-width: 576px)');
    const FlexTag = isMobileView ? BlockStack : InlineStack;
    const parentData = responseData?.parent || {};
    const childData = responseData?.child || {};
    // Add state for expanded messages
    const [expandedMessages, setExpandedMessages] = useState<Set<string>>(new Set());

    useEffect(() => {
        if (!viewProductError) return;
        const payload: any = {
            isParent: type === 'parent' ? true : false,
        };
        if (type == 'child') {
            payload['source_product_id'] = id
        } else {
            payload['container_id'] = id
        }
        di?.POST('connector/product/getErrorProcessTag', payload).then((response: any) => {
            if (response.success) {
                setResponseData(response.data);
            } else {
                showError(response.message);
            }
        });
    }, [viewProductError]);

    if (!viewProductError || !responseData) return null;
    // Add this special counter for process tags
    const getProcessTagCount = () => {
        const parentProcess = responseData?.parent?.process_tags || {};
        const childProcess = responseData?.child?.process_tags || {};

        // Merge keys and remove duplicates
        const allKeys = [
            ...Object.keys(parentProcess),
            ...Object.keys(childProcess)
        ];
        return new Set(allKeys).size;
    };

    const getEntries = (dataKey: string, data: any) => {
        if (dataKey === 'process_tags') {
            return Object.entries(data[dataKey] || {}).map(([key, value]: any) => ({
                code: key,
                message: value.msg,
                time: value.time,
            }));
        }
        return data[dataKey] || [];
    };

    // Update the tabData declaration
    const tabData = [
        {
            id: 'Error(s)',
            content: 'Error(s)',
            dataKey: 'error',
            tone: 'critical',
            parentCount: getEntries('error', parentData).length,
            variantCount: getEntries('error', childData).length,
            count:
                getEntries('error', parentData).length +
                getEntries('error', childData).length,
        },
        {
            id: 'Warning(s)',
            content: 'Warning(s)',
            dataKey: 'warning',
            tone: 'warning',
            parentCount: getEntries('warning', parentData).length,
            variantCount: getEntries('warning', childData).length,
            count:
                getEntries('warning', parentData).length +
                getEntries('warning', childData).length,
        },
        {
            id: 'In-progress',
            content: 'In-progress',
            dataKey: 'process_tags',
            tone: 'success',
            count: getProcessTagCount(),
        },
    ];



    const selectedTab = tabData[selectedMainTab];
    const selectedSubTab = selectedSubTabs[selectedMainTab];


    const parentItems = getEntries(selectedTab.dataKey, parentData);
    const childItems = getEntries(selectedTab.dataKey, childData);
    const selectedItems = selectedSubTab === 0 ? parentItems : childItems;

    const groupByType = (items: any[]) => {
        return items.reduce((acc: any, item) => {
            if (!acc[item.type]) {
                acc[item.type] = [];
            }
            acc[item.type].push(item);
            return acc;
        }, {});
    };
    const renderItems = () => {
        const selectedTab = tabData[selectedMainTab];
        console.log(selectedMainTab, "cfvgbhjnmkfvgbhnj")
        if (selectedMainTab === 0) {
            // Error tab selected
            if (selectedSubTabs[0] === 0) {
                // Parent sub-tab
                const errorItems = responseData?.parent?.error || [];
                const groupedItems = groupByType(errorItems);
                if (Object.keys(groupedItems).length === 0) {
                    return (
                        <Text as="p" variant="bodyMd" tone="subdued">
                            No {selectedTab.content.toLowerCase()} found for Parent.
                        </Text>
                    );
                }

                return (
                    <BlockStack gap="300">
                        <InlineStack gap={"300"} blockAlign='center' wrap={false}>
                            <Thumbnail size='small' source={'https://cdn.shopify.com/s/files/1/0637/2632/1718/files/2015-03-30_Jake_Look_09_21479_16453_a94d7a62-8e21-4ffa-98eb-3929cd7af4e8_40x40@3x.jpg'} alt='product-img' />
                            <Text as='p' variant='bodyMd' fontWeight='medium'>Book Nest Deluxe Organizer and Display Shelf</Text>
                        </InlineStack>
                        <BlockStack gap={"400"}>
                            {Object.keys(groupedItems).map((item: any, idx: number) => {

                                return (<BlockStack gap={"200"}>
                                    <Text as='p' variant='bodyMd' fontWeight='medium'>{`${item} Error(s)`}</Text>
                                    {
                                        groupedItems?.[item]?.map((data: any) => {
                                            return (<InlineStack gap={"200"} blockAlign='start' wrap={false}>
                                                <span> <Icon source={RiskMinor} tone='critical' /></span>
                                                 <ErrorMessage errorText={data?.label ? `${data?.label ?? ""}: ${data.message}` : data.message} />
                                            </InlineStack>)
                                        })
                                    }
                                </BlockStack>)
                            })}
                        </BlockStack>

                    </BlockStack>
                );
            } else if (selectedSubTabs[0] === 1) {
                // Variant sub-tab
                const errorItems = responseData?.child?.error || [];
                const groupedItems = groupByType(errorItems);
                if (Object.keys(groupedItems).length === 0) {
                    return (
                        <Text as="p" variant="bodyMd" tone="subdued">
                            No {selectedTab.content.toLowerCase()} found for Variant.
                        </Text>
                    );
                }
                return (
                    <BlockStack gap={"400"}>
                        {Object.keys(groupedItems).map((item: any, idx: number) => {

                            return (<BlockStack gap={"200"}>
                                <Text as='p' variant='bodyMd' fontWeight='medium'>{`${item} Error(s)`}</Text>
                                {
                                    groupedItems?.[item]?.map((data: any) => {
                                        return (<InlineStack gap={"200"} blockAlign='start' wrap={false}>
                                            <span> <Icon source={RiskMinor} tone='critical' /></span>
                                             <ErrorMessage errorText={data?.label ? `${data?.label ?? ""}: ${data.message}` : data.message} />
                                            {/* <Text as='p' variant='bodyMd'>{data?.message}</Text> */}
                                        </InlineStack>)
                                    })
                                }
                            </BlockStack>)
                        })}
                    </BlockStack>
                );
            }
        }
        else if (selectedMainTab === 1) {
            // Error tab selected
            if (selectedSubTabs[1] === 0) {
                // Parent sub-tab
                const errorItems = responseData?.parent?.warning || [];
                const groupedItems = groupByType(errorItems);

                if (Object.keys(groupedItems).length === 0) {
                    return (
                        <Text as="p" variant="bodyMd" tone="subdued">
                            No {selectedTab.content.toLowerCase()} found for Parent.
                        </Text>
                    );
                }

                return (
                    <BlockStack gap="300">
                        <InlineStack gap={"300"} blockAlign='center' wrap={false}>
                            <Thumbnail size='small' source={'https://cdn.shopify.com/s/files/1/0637/2632/1718/files/2015-03-30_Jake_Look_09_21479_16453_a94d7a62-8e21-4ffa-98eb-3929cd7af4e8_40x40@3x.jpg'} alt='product-img' />
                            <Text as='p' variant='bodyMd' fontWeight='medium'>Book Nest Deluxe Organizer and Display Shelf</Text>
                        </InlineStack>
                        <BlockStack gap={"400"}>
                            {Object.keys(groupedItems).map((item: any, idx: number) => {
                                return (<BlockStack gap={"200"}>
                                    <Text as='p' variant='bodyMd' fontWeight='medium'>{`${item} Warning(s)`}</Text>
                                    {
                                        groupedItems?.[item]?.map((data: any) => {
                                            return (<InlineStack gap={"200"} blockAlign='start' wrap={false}>
                                                <span> <Icon source={RiskMinor} tone='critical' /></span>
                                                <Text as='p' variant='bodyMd'>{data?.message}</Text>
                                            </InlineStack>)
                                        })
                                    }
                                </BlockStack>)
                            })}
                        </BlockStack>

                    </BlockStack>
                );
            } else if (selectedSubTabs[1] === 1) {
                // Variant sub-tab

                const errorItems = responseData?.child?.warning || [];
                const groupedItems = groupByType(errorItems);
                if (Object.keys(groupedItems).length === 0) {
                    return (
                        <Text as="p" variant="bodyMd" tone="subdued">
                            No {selectedTab.content.toLowerCase()} found for Variant.
                        </Text>
                    );
                }
                return (
                    <BlockStack gap={"400"}>
                        {Object.keys(groupedItems).map((item: any, idx: number) => {

                            return (<BlockStack gap={"200"}>
                                <Text as='p' variant='bodyMd' fontWeight='medium'>{`${item} Warning(s)`}</Text>
                                {
                                    groupedItems?.[item]?.map((data: any) => {
                                        return (<InlineStack gap={"200"} blockAlign='start' wrap={false}>
                                            <span> <Icon source={RiskMinor} tone='critical' /></span>
                                            <Text as='p' variant='bodyMd'>{data?.message}</Text>
                                        </InlineStack>)
                                    })
                                }
                            </BlockStack>)
                        })}
                    </BlockStack>
                );
            }
        }
        else if (selectedMainTab === 2) {
            const errorItems = { ...responseData?.parent?.process_tags, ...responseData?.child?.process_tags }
            if (Object.keys(errorItems).length === 0) {
                return (
                    <Text as="p" variant="bodyMd" tone="subdued">
                        {t("No Activity found.")}
                    </Text>
                );
            }
            return (
                <BlockStack gap="300">
                    {Object.keys(errorItems).map((item: any, idx: number) => {
                        return (
                            <>
                                {idx !== 0 && <Divider></Divider>}
                                <InlineStack blockAlign='center' align='space-between'>
                                    <BlockStack gap={'200'}>
                                        <Text as='p' variant='bodyMd' fontWeight='medium'>{item}</Text>
                                        <Text as='p' variant='bodyMd' tone='subdued'>{errorItems?.[item]?.time}</Text>

                                    </BlockStack>
                                    <Text as="p" variant="bodyMd" tone='subdued'>{errorItems?.[item]?.msg}</Text>
                                </InlineStack>

                            </>
                        )
                    }
                    )}

                </BlockStack>
            );
        }

        // Future: Add Warning and In-progress cases here
        return null;
    };

    return (
        <Modal open={viewProductError} primaryAction={selectedMainTab == 2 ? {
            onAction: () => activityRefreshAction(),
            content: t('Refresh to update status'),
        } : undefined} onClose={() => setViewProductError(false)} title="Action(s) in progress" size="large">
            <FlexTag>
                <div className={getClass({ 'flex-1': isMobileView })}>
                    <Box background="bg-surface-secondary" padding="400" minHeight="100%">
                        <div className={getClass({ 'custom-vertical-tab': !isMobileView })}>
                            <CustomTabs
                                onSelect={(index: number) => {
                                    setSelectedMainTab(index);
                                }}
                                selected={selectedMainTab}
                                tabs={tabData.map((tab: any, index) => ({
                                    id: `${tab.id}-${index}`,
                                    content: (
                                        <span className="custom-error-tab-tag">
                                            <span>{tab.content}</span>
                                            <Badge tone={tab.tone}>
                                                {tab.dataKey === 'process_tags'
                                                    ? getProcessTagCount()
                                                    : getEntries(tab.dataKey, parentData).length + getEntries(tab.dataKey, childData).length}
                                            </Badge>
                                        </span>
                                    ) as any,
                                }))}
                            />
                        </div>
                    </Box>
                </div>
                <div className={getClass({ 'custom-ver-divider flex-1': !isMobileView })}>
                    <Box padding="400">
                        {selectedMainTab !== 2 && (
                            <Tabs
                                tabs={[
                                    {
                                        id: 'parent',
                                        content: (
                                            <InlineStack gap="100" align="center">
                                                <Text as="span" variant="bodyMd" fontWeight="medium">
                                                    Product {tabData[selectedMainTab].content}
                                                </Text>
                                                <Badge >
                                                    {getEntries(tabData[selectedMainTab].dataKey, parentData).length}
                                                </Badge>
                                            </InlineStack>
                                        ),
                                        panelID: 'parent-tab',
                                    },
                                    {
                                        id: 'variant',
                                        content: (
                                            <InlineStack gap="100" align="center">
                                                <Text as="span" variant="bodyMd" fontWeight="medium">
                                                    Variant {tabData[selectedMainTab].content}
                                                </Text>
                                                <Badge >
                                                    {getEntries(tabData[selectedMainTab].dataKey, childData).length}
                                                </Badge>
                                            </InlineStack>
                                        ) as any,
                                        panelID: 'variant-tab',
                                    },
                                ]}
                                selected={selectedSubTabs[selectedMainTab]}
                                onSelect={(index: number) => {
                                    setSelectedSubTabs((prev) => {
                                        const updated = [...prev];
                                        updated[selectedMainTab] = index;
                                        return updated;
                                    });
                                }}
                            />
                        )}
                        <Card padding="300">{renderItems()}</Card>
                    </Box>
                </div>
            </FlexTag>
            <Divider borderColor="border" />
            <Box padding="400">
                {t("Can’t find the solution? Email us at")} {" "}<Link url={`mailto:support@cedcommerce.com?subject=${encodeURIComponent(`${props?.di?.globalState?.get("username") ?? props?.redux?.current?.source?.name ?? "Seller"} has a question about ${process.env.REACT_APP_NAME_AND_ENV ?? "Cedcommerce Amazon Channel"}`)}`} target='_blank'>{t("support@cedcommerce.com ")}</Link>{t("for quick assistance")}
            </Box>
        </Modal>
    );
};

export default DI(ErrorModal);


export function ErrorMessage({ errorText }: { errorText: string }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggle = () => setIsExpanded(!isExpanded);

    const truncatedText = errorText.length > 120 ? errorText.slice(0, 120) + '...' : errorText;

    return (
        <div>
            <p>
                {isExpanded ? errorText : truncatedText}
                {errorText.length > 120 && (
                    <Button onClick={handleToggle} variant='plain'>{isExpanded ? ' show less' : ' read more'}</Button>
                )}
            </p>
        </div>
    );
}
